import { render } from "./Sync.vue?vue&type=template&id=c23ad6e4"
import script from "./Sync.vue?vue&type=script&lang=js"
export * from "./Sync.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Development\\app.vrtag.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__